import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class ExcelOrderImport_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public ExcelOrderImport: ExcelOrderImport_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

